import Navbar from "./Components/Navbar";
import Footer from "./Components/footer";
import { BrowserRouter as Router, Routes, Route,useNavigate } from "react-router-dom";
import Home from "./Pages/Home";
import TheJourney from "./Pages/TheJourney";
import WhatsappFloat from "./Components/WhatsappFloat";
import ScrollButton from "./Components/ScrollButton";
import ContactUs from "./Pages/ContactUs";
import ScrollToTop from "./Components/ScrollToTop";
import Products from "./Pages/Products";
import Checkout from "./Pages/Checkout";
import Policy from "./Pages/privacyPolicy";
import ReturnPolicy from "./Pages/ReturnPolicy";
import TermsnCondition from "./Pages/TermsnCondition";
import swal from "sweetalert";
import Context, { CartState } from "./Context/Context";
import {  useRef } from "react";
import Affiliate from "./Pages/Affiliate";
import Combo from "./Pages/Combo";
import AdminLogIn from "./Components/AdminLogInModal";
import ProductDetails from "./Pages/ProductDetails";
import Admin from "./AdminComponent/Admin"
import ProductState from './Context/productState'
import { AuthProvider } from "./Context/AuthContext";
import Orders from "./AdminComponent/Orders";




function App() {
  const {
    state:
    { cart, }
    
  }= CartState();

  

  const scrollToDiv = (ref) => {
    window.scrollTo(0, ref.current.offsetTop)
  };
  const whyDokmenRef = useRef()

  const showAlert=()=>{
return swal({
  title:"Under Construction",
  text:"This Page is Under Construction",
  icon:"warning"

})
  }



 
  

  return (
    <>
    <AuthProvider>
    <ProductState>
     <Router>
      <ScrollToTop />
    <Navbar click={()=>scrollToDiv(whyDokmenRef)} showAlert={showAlert}/>
      
      <Routes>
        <Route path="" element={<Home whyDokmenRef={whyDokmenRef}/>}></Route>
        <Route path="/journey" element={<TheJourney />}></Route>
        <Route path="/contactus" element={<ContactUs />}></Route>
        <Route path="/products" element={<Products  />}></Route>
        <Route  path="/checkout" element={<Checkout />}></Route>
        <Route path="/privacypolicy" element={<Policy/>}></Route>
        <Route path="/returnpolicy" element={<ReturnPolicy/>}></Route>
        <Route path="/terms&condition" element={<TermsnCondition/>}></Route>
        <Route path="/affiliate" element={<Affiliate/>}></Route>
        <Route path="/combo" element={<Combo/>}></Route>
        <Route path="/productdetails" element={<ProductDetails/>}></Route>
        <Route path="/admin" element={<Admin/>}></Route>


      </Routes>
      <AdminLogIn/>
      <ScrollButton></ScrollButton>
      <WhatsappFloat></WhatsappFloat>
      <Footer showAlert={showAlert} click={()=>scrollToDiv(whyDokmenRef)}></Footer>
    </Router>
    </ProductState>
    </AuthProvider>
    </>
  );
}

export default App;
